// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewAll_wrapper__LPdhb","title":"ViewAll_title__BE1WH","image":"ViewAll_image__JXxVW"};